module.exports = __webpack_public_path__ + "img/star.90f03d92.png";